export const fall_2026_2260_materials = {
    notes: [
        {
           name: "Review of Integration (class notes)",
           link: "https://drive.google.com/file/d/1HZiL2yocTFHd3EiZ1Y3aVXSYR-kXEQSf/view?usp=sharing"
           },
           {
            name: "Integrals Review (8/19 activity)",
            link: "https://drive.google.com/file/d/1j4QSW5ajkZTIyBLitKCdMkyRsQ1bWkjd/view?usp=sharing"
           },
           {
            name: "Applications of Integration (class notes)",
            link: "https://drive.google.com/file/d/1eQzf5FkuzqUvo4eMdwkTfCSg3OCURr7i/view?usp=sharing"
           },
           {
            name: "Volumes of Rotation (8/26 activity)",
            link: "https://drive.google.com/file/d/1ramZQ90jfcEZJvasw39KYWjiXcA3S9It/view?usp=sharing"
           },
           {
            name: "More Applications of Integration (9/2 activity)",
            link: "https://drive.google.com/file/d/1ETZrCckobDR2liYkb4uX33UeM18jqvYf/view?usp=sharing"
           },
           {
            name: "Techniques of Integration (class notes)",
            link: 'https://drive.google.com/file/d/1R6u-NU3SB3u79gaxjcakm3uAZsv0OHrk/view?usp=sharing'
           },
           {
            name: "Some Integrals (take home assignment, due 9/15)",
            link: "https://drive.google.com/file/d/17A10zDusO3a0uCAmwL3Qh_k8JlWtnTpQ/view?usp=sharing"
           },
           {
            name: "Trig integrals (9/16 activity)",
            link: "https://drive.google.com/file/d/1U72u3aFj7bRznvgAgBRyPL0QoVHUWGrW/view?usp=sharing"
           },
           {
            name: "Improper Integrals and Sequences (9/30 activity)",
            link: "https://drive.google.com/file/d/1OHxYTdVVTz-tvf52XMPgQ0u1AYoIK4Ra/view?usp=sharing"
           },
           {
            name: "Sequences and series (in class notes)",
            link: "https://drive.google.com/file/d/1VZLqK1qJhJDtVYr4oRJOeyuWB4xsAe97/view?usp=sharing"
           },
           {
            name: "Series (10/7 activity)",
            link: "https://drive.google.com/file/d/1cmdtsn9lid0SS5FWJ9H8KRC2x6pvyg3s/view?usp=sharing"
           },
           {
            name: "More Series (10/14 activity)",
            link: "https://drive.google.com/file/d/1Gi6MzJ5PAFfqUKOCTsfM40Lndo34EyNY/view?usp=sharing"
           },
           {
            name: "Power Series (10/21 activity)",
            link: "https://drive.google.com/file/d/1PDK3haa9PXnzJuGycuH9n7zEK1IMWkh0/view?usp=sharing"
           },
           {
            name: "Vectors (11/4 activity)",
            link: "https://drive.google.com/file/d/1iyrvEmVjNtp_rDMCAD3_prmNuwotVl9i/view?usp=sharing"
           }
    ],
    quizzes: [
        {
           name: "Quiz 0",
           link: "https://drive.google.com/file/d/1JGbdaKElrkffQ0vwpmVDvZcYDCrXOJLl/view?usp=sharing"
        },
        {
            name: "Quiz 1",
            link: "https://drive.google.com/file/d/1j8lz_PyCozQtYrzrGb_T-VmCOfGbKpwM/view?usp=sharing"
        },
    ],
    exam: [
        {
           name: "Ideas for Exam 1",
            link: "https://drive.google.com/file/d/1kB7RCT5ZctsYKUsfx_V62CzEttmErDpL/view?usp=sharing"
        },
        {
            name: "Ideas for Exam 2",
            link: "https://drive.google.com/file/d/1fxvezWelD0n6n9iYr7an46VTRGlSqfCj/view?usp=sharing"
        },
    ],
}



// WEBPACK FOOTER //
// ./src/data/materials/fall_2026_2260_materials.js